// extracted by mini-css-extract-plugin
export var addToCartButton = "_t1-b";
export var arrowButtonContainer = "_t1-9";
export var arrowButtonIcon = "_t1-a";
export var carouselArrowButton = "_t1-6";
export var carouselElementContainer = "_t1-1";
export var galleryThumbnail = "_t1-d";
export var galleryThumbnailImage = "_t1-e";
export var left = "_t1-7";
export var productDisplayCarouselContainer = "_t1-0";
export var productTileContainer = "_t1-2";
export var productTileImage = "_t1-4";
export var productTileImageContainer = "_t1-3";
export var productTileTitle = "_t1-5";
export var right = "_t1-8";
export var sliderOverflow = "_t1-c";